import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'

import { STRING, EVENT_TYPE } from 'resources'
import { APP_URLS } from 'resources/urls'

import { sendAnalyticsEvent } from 'services/analytics'

import { ModalTitle } from 'components/ReklaimModal'

import { ModalDescription, Button, IdentifierContainer } from './styles'

const EmailAddressAddSuccess = ({ closeModal, hasUnveilProfileToBeScanned, emailAddress }) => {
  const history = useHistory()

  useEffect(() => {
    sendAnalyticsEvent(EVENT_TYPE.accountAddEmailAddressModalVerificationSuccessView, {
      emailAddress,
      hasProfile: hasUnveilProfileToBeScanned,
    })
  }, [emailAddress, hasUnveilProfileToBeScanned])

  const handleContinueClick = () => {
    if (hasUnveilProfileToBeScanned) {
      history.push(APP_URLS.FULL_UNVEIL)
    } else {
      closeModal()
    }
  }

  return (
    <>
      <IdentifierContainer>{emailAddress}</IdentifierContainer>
      <ModalTitle>{STRING.account.addNewEmailAddressModal.emailAddressAddSuccess.title}</ModalTitle>
      <ModalDescription>{STRING.account.addNewEmailAddressModal.emailAddressAddSuccess.message}</ModalDescription>
      <Button onClick={handleContinueClick}>
        {hasUnveilProfileToBeScanned
          ? STRING.account.addNewEmailAddressModal.emailAddressAddSuccess.button
          : STRING.account.addNewEmailAddressModal.emailAddressAddSuccess.continue}
      </Button>
    </>
  )
}

EmailAddressAddSuccess.propTypes = {
  closeModal: PropTypes.func.isRequired,
  hasUnveilProfileToBeScanned: PropTypes.bool.isRequired,
  emailAddress: PropTypes.string.isRequired,
}

export default EmailAddressAddSuccess
